import axios from 'axios';
import {getItem} from '../utils/storage';
import { getApiDomain } from '../agent/config';
import getV2AxiosInstance from '../utils/v2Axios.js';

export function setOutcomeList(data){
    return {
        type: 'SET_OUTCOME_LIST',
        payload: data
    };
}
/**
 * returns response or error of api call
 * @param  {object} response [response of api call]
 * @return {object}          [response or error]
 */
function handleResponse(response){
  if(response.status==200){
    return response;
  }else{
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

/**
 * gets list of end business type list
 * @param  {string} service_id
 */
export function getOutcomeList(service_id){
    return dispatch => {
      return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Service", {
        action: "listEndBusinessByServiceId",
        params: { agent_id: localStorage.getItem("agent_id"),
        service_id: service_id, },
      })
      .then(handleResponse)
        .then(data => dispatch(setOutcomeList(data.data.response.items)))
    };
}

/**
 * sets business outcome
 * @param {object} payload
 */
export function setEndBusiness(payload){
    return (dispatch) => {
      return getV2AxiosInstance()
        .post("/bridge/en/invoxapi/Call", {
          action: "setEndBusinessByCallId",
          params: {
            agent_id: localStorage.getItem("agent_id"),
            call_id: payload.callId,
            end_business_id: payload.id,
          },
        })
        .then(handleResponse);
    };
}



// WEBPACK FOOTER //
// ./src/actions/businessOutcome.js